import React, { useEffect, useRef, useState, useCallback, useMemo } from 'react';
import { TfiTrash } from "react-icons/tfi";
import { Gantt, ViewMode } from 'gantt-task-react';
import "gantt-task-react/dist/index.css";
import { LuSearch, LuCalendar, LuUser, LuClock, LuAlertTriangle } from "react-icons/lu";
import { connect } from "react-redux";
import { compose } from "redux";
import { LuCircleAlert } from "react-icons/lu"
//import { CSSTransition } from 'react-transition-group';
import { getDepartmentsFindings, getDepartmentsActionData, getDepartments, getDepartmentsAction, addActionComments, editActionComments } from "../../store/actions/departmentActions";
import { updateFinding, createActionFromFinding, markFindingsOpen, markFindingsComplete, addActionsFromFindings, editActionProgress, editAction } from "../../store/actions/riskActions";
import {getComplianceFindings} from "../../store/actions/complianceActions"

import debounce from "lodash/debounce";
import { Disable } from 'react-disable';
import { useTranslation } from "react-i18next";
import { translateFindingStatusDisplay, translatePriorityDisplay } from "../../utils/i18nDisplayLabels";

import { FiAlertTriangle, FiXCircle, FiClock, FiCheckCircle } from "react-icons/fi";
import { AlertTriangle, Clock, XCircle, CheckCircle2 } from "lucide-react";
import "./Gantt.css";

import Select from 'react-select'

import { PageSection, KpiStrip, FilterBar, SearchInput, ModuleViewToggle } from "../ui";


import ActionOverlay from "../Action/ActionOverlay";
import FindingOverlay from '../Control/FindingOverlay';
import { PageSpinner } from "../../components/ui";
const customStyles = {
    control: (provided, state) => ({
        ...provided,
        borderColor: state.isFocused ? '#3b3b3b' : '#ccc',
        boxShadow: state.isFocused ? '0 0 0 1px #3b3b3b' : 'none',
        '&:hover': {
            borderColor: '#3b3b3b',
        },
        backgroundColor: '#EEF0ED',
        padding: 1,
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 999999999999, // Ensures the menu appears above other elements
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#3b3b3b' : state.isFocused ? '#EEF0ED' : 'white',
        color: state.isSelected ? 'white' : '#3b3b3b',
        '&:hover': {
            // backgroundColor: '#EEF0ED',
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#3b3b3b',
    }),
};



const statusMeta = {
    "Not started": { cls: "bg-gray-100 text-gray-700 border-gray-200" },
    "In progress": { cls: "bg-blue-100 text-blue-700 border-blue-200" },
    "Completed": { cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
    "Problem": { cls: "bg-rose-100 text-rose-700 border-rose-200" },
};

function chipCls(label) {
    const m = label && statusMeta[label];
    return `inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs border ${m ? m.cls : "bg-gray-100 text-gray-700 border-gray-200"
        }`;
}

function isCompleted(label) {
    return label === "Completed";
}

function isBehind(t) {
    try {
        if (t.styles && t.styles.backgroundColor === "#F07167") return true; // backend hint
        const start = new Date(t.start);
        const end = new Date(t.end);
        const now = new Date();
        const total = end - start;
        const elapsed = now - start;
        const frac = total > 0 ? elapsed / total : 0;
        const pct = Number(t.progress || 0);
        return pct < frac * 100 && !isCompleted(t.progressLabel);
    } catch {
        return false;
    }
}

function isOverdue(t) {
    try {
        return new Date(t.end) < new Date() && !isCompleted(t.progressLabel);
    } catch {
        return false;
    }
}




const FindingsComponent = (props) => {

    const { t } = useTranslation();

    const {compFindings, activeComplianceId, isComp, embedded, nested, hideStatsAndToggle, getComplianceFindingsFN,  onSelectFindings, onSelectActions, initialfindings, updateFindingFN, createActionFromFindingFN, markFindingsOpenFN, markFindingsCompleteFN, makeActionsFN, actions_stats, getDepartmentsFindingsFN, getDepartmentsActionDataFN, departments, getDepartmentsFN, getDepartmentsActionFN, actions, addActionCommentsFN, editActionFN, editActionCommentsFN, activeDepartmentId, profile, findingsScopeKey, findingsLoading, compFindingsScopeKey, compFindingsLoading, onActionCreated } = props;

    ////////console.log("ACTIONS GANTT :", actions);
    // Step 1: Initialize state for input values
    const [tasks, setTasks] = useState([]);

    const [isLoading, setIsLoading] = useState(true);


    const [risk_id, setRiskId] = useState(null);
    const [isActionOpen, setIsActionOpen] = useState(false);
    const [action_id, setActionId] = useState(null);

    const [findingId, setFindingID] = useState(null);
    const [isFindingOpen, setIsFindingOpen] = useState(false);

    // const [taskDescription, setTaskDescription] = useState("");


    // eslint-disable-next-line react-hooks/exhaustive-deps



    const [findings, setFindings] = useState([]);

  const isFindingsLoading = useMemo(() => {
    if (isComp) {
      if (!activeComplianceId) return false;
      const expected = `comp:${activeComplianceId}`;
      if (compFindingsLoading) return true;
      return compFindingsScopeKey !== expected;
    }
    if (!activeDepartmentId) return false;
    const expected = `dept:${activeDepartmentId}`;
    if (findingsLoading) return true;
    return findingsScopeKey !== expected;
  }, [
    isComp, activeComplianceId, activeDepartmentId,
    findingsLoading, findingsScopeKey, compFindingsLoading, compFindingsScopeKey,
  ]);

  const scopedInitialFindings = useMemo(() => {
    if (isComp) {
      if (compFindingsScopeKey !== `comp:${activeComplianceId}`) return [];
      return compFindings ?? [];
    }
    // No department scope (e.g. embedded in ControlPage for a specific control) — use prop directly
    if (!activeDepartmentId) return initialfindings ?? [];
    if (findingsScopeKey !== `dept:${activeDepartmentId}`) return [];
    return initialfindings ?? [];
  }, [
    isComp, activeComplianceId, activeDepartmentId,
    initialfindings, compFindings, findingsScopeKey, compFindingsScopeKey,
  ]);

  useEffect(() => {
  if (isComp) return;

    const list = Array.isArray(scopedInitialFindings)
      ? scopedInitialFindings
      : Array.isArray(scopedInitialFindings?.findings)
        ? scopedInitialFindings.findings
        : [];

    const byId = new Map();
    for (const f of list) {
      byId.set(String(f.finding_id ?? f.id), f);
    }

    const clean = Array.from(byId.values()).sort(
      (a, b) => Number(a.finding_id ?? a.id ?? 0) - Number(b.finding_id ?? b.id ?? 0)
    );
    setFindings(clean);
  }, [scopedInitialFindings, isComp]);


       useEffect(() => {
        if (!compFindings || !isComp) return;
        if (compFindingsScopeKey !== `comp:${activeComplianceId}`) {
            setFindings([]);
            return;
        }

        const list = Array.isArray(compFindings)
            ? compFindings
            : Array.isArray(compFindings?.findings)
                ? compFindings.findings
                : [];
        const byId = new Map();
        for (const f of list) {
            byId.set(String(f.finding_id ?? f.id), f);
        }

        const clean = Array.from(byId.values()).sort(
            (a, b) => Number(a.finding_id ?? a.id ?? 0) - Number(b.finding_id ?? b.id ?? 0)
        );

        setFindings(clean);
    }, [compFindings, isComp, compFindingsScopeKey, activeComplianceId]);



    useEffect(() => {
        if (activeDepartmentId) {
            if (profile?.role !== "User") {
                getDepartmentsFindingsFN(activeDepartmentId);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeDepartmentId, profile?.role]);


  useEffect(() => {
    if (activeComplianceId && isComp) {
      //alert(activeDepartmentId);

      getComplianceFindingsFN(activeComplianceId);

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeComplianceId, isComp]);

  //   useEffect(() => {
  //   if (!activeComplianceId && isComp) {
  //     //alert(activeDepartmentId);

  //     getComplianceFindingsFN(0);

  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [activeComplianceId, isComp]);

  useEffect(() => {
    if (!activeDepartmentId) {
      getDepartmentsFindingsFN(0);
      getDepartmentsActionFN?.(0);
      getDepartmentsActionDataFN?.(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeDepartmentId]);

  useEffect(() => {
    if (!actions_stats) return;
    const list = Array.isArray(actions_stats) ? actions_stats : [];
    setTasks(list);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actions_stats]);


    const [activeDepartment, setActiveDepartment] = useState(activeDepartmentId ? activeDepartmentId : null);

    useEffect(() => {

        getDepartmentsFN();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {


        if (profile?.department_id && profile?.role === "User") {
            setActiveDepartment(profile.department_id);
            getDepartmentsFindingsFN(profile.department_id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profile]);

    useEffect(() => {


        if (activeDepartmentId) {
            setActiveDepartment(activeDepartmentId)

        }
    }, [activeDepartmentId]);

    const ganttWrapperRef = useRef(null);

    useEffect(() => {
        if (ganttWrapperRef.current) {
            // Use timeout to wait for Gantt to finish its own scroll logic
            setTimeout(() => {
                ganttWrapperRef.current.scrollLeft = 0;
            }, 100); // 100ms usually works — adjust if needed
        }
    }, [tasks]); // Runs every time tasks change




    // local UI state
    const [q, setQ] = useState("");
    const [statusFilter, setStatusFilter] = useState("All");
    const [onlyMine, setOnlyMine] = useState(false);

    const counts = useMemo(() => {
        let open = 0,
            closed = 0,
            inProgress = 0;

        (findings || []).forEach((f) => {
            const s = (f.status || "").toLowerCase();
            if (s === "closed") closed++;
            else if (s === "problem") inProgress++;
            else open++;
        });

        return { open, inProgress, closed, total: findings?.length || 0 };
    }, [findings]);

    const isRiskCenter = embedded || nested;

    const findingsKpiItems = useMemo(() => [
        {
            key: "total",
            label: t("findingsPage.summary.totalFindings"),
            value: counts.total,
            icon: AlertTriangle,
            iconBg: "bg-gray-100",
            iconColor: "text-gray-600",
            valueClassName: "text-gray-900",
        },
        {
            key: "open",
            label: t("findingsPage.summary.openFindings"),
            value: counts.open,
            icon: Clock,
            iconBg: "bg-blue-50",
            iconColor: "text-blue-600",
            valueClassName: "text-blue-600",
        },
        {
            key: "inProgress",
            label: t("findingsPage.summary.inProgress"),
            value: counts.inProgress,
            icon: XCircle,
            iconBg: "bg-orange-50",
            iconColor: "text-orange-600",
            valueClassName: "text-orange-600",
        },
        {
            key: "closed",
            label: t("findingsPage.summary.closed"),
            value: counts.closed,
            icon: CheckCircle2,
            iconBg: "bg-emerald-50",
            iconColor: "text-emerald-600",
            valueClassName: "text-emerald-600",
        },
    ], [counts, t]);

    const meId = profile && profile.user_id ? Number(profile.user_id) : null;

    const filtered = useMemo(() => {
        let list = [...tasks];

        if (statusFilter !== "All") {
            list = list.filter((t) => (t.progressLabel || "Not started") === statusFilter);
        }

        if (q.trim()) {
            const L = q.toLowerCase();
            list = list.filter(
                (t) => (t.name || "").toLowerCase().includes(L) || (t.project || "").toLowerCase().includes(L)
            );
        }

        if (onlyMine && meId) {
            list = list.filter(
                (t) => (t.assignees || []).some((u) => Number(u.id) === meId) || (t.riskOwner && Number(t.riskOwner.id) === meId)
            );
        }

        // prioritize overdue/behind, then nearest due date
        list.sort((a, b) => {
            const sa = isOverdue(a) ? 2 : isBehind(a) ? 1 : 0;
            const sb = isOverdue(b) ? 2 : isBehind(b) ? 1 : 0;
            if (sa !== sb) return sb - sa;
            return new Date(a.end) - new Date(b.end);
        });

        return list;
    }, [tasks, q, statusFilter, onlyMine, meId]);



    const getControlTitle = (f) =>
        f.control_title && f.control_title.trim()
            ? f.control_title.trim()
            : (f.control_id ? `Control #${f.control_id}` : "—");

    const normalize = (s) => (s || "").toString().toLowerCase().trim();

    // ---- component body ----
    const [qFind, setQFind] = useState("");
    const filteredFindings = (findings || []).filter((f) => {
        const q = normalize(qFind);
        if (!q) return true;
        return (
            normalize(f.risk_title).includes(q) ||
            normalize(getControlTitle(f)).includes(q) ||
            normalize(f.finding_text).includes(q)
        );
    });


    const [selected, setSelected] = useState(new Set());

    // stable row key (matches your original intent)
    const rowKey = (f) => String(f.finding_id ?? f.id);

    // convenience
    const allIds = filteredFindings.map(rowKey);
    const allSelected = selected.size > 0 && allIds.every((id) => selected.has(id));

    const toggleRow = (id) => {
        setSelected((prev) => {
            const next = new Set(prev);
            next.has(id) ? next.delete(id) : next.add(id);
            return next;
        });
    };

    const toggleAll = () => {
        setSelected((prev) => {
            if (allIds?.length === 0) return new Set();
            const next = new Set(prev);
            const selectingAll = !allIds.every((id) => next.has(id));
            if (selectingAll) {
                allIds.forEach((id) => next.add(id));
            } else {
                allIds.forEach((id) => next.delete(id));
            }
            return next;
        });
    };

    const clearSelection = () => setSelected(new Set());

    // map selected ids back to finding objects
    const selectedFindings = filteredFindings.filter((f) => selected.has(rowKey(f)));

    const handleMakeActions = async () => {
        if (!selectedFindings?.length) return;
        await makeActionsFN?.(selectedFindings);
        clearSelection();
    };

    const handleViewAction = async (finding) => {
        ////console.log("View ", finding)
        setRiskId(finding.action_risk_id)
        setActionId(finding.action_id)
        setIsActionOpen(true)

    };

    const handleViewFinding = (finding) => {
        ////console.log("view ,", finding)
        setFindingID(finding.finding_id ?? finding.id);
        setIsFindingOpen(true)
    }

  const handleCreateAction = async (finding) => {
    if (!finding) return;

    try {
      const data = await createActionFromFindingFN(finding);
      const actionId = data?.finding?.action_id;
      const actionRiskId = data?.action?.risk_id ?? null;
      const findingId = data?.finding?.finding_id ?? finding.finding_id ?? finding.id;

      if (actionId) {
        setFindings((prev) =>
          prev.map((f) =>
            String(f.finding_id ?? f.id) === String(findingId)
              ? { ...f, action_id: actionId, action_risk_id: actionRiskId ?? f.action_risk_id ?? null }
              : f
          )
        );
      }

      if (onActionCreated) {
        await onActionCreated(data);
      } else if (isComp) {
        getComplianceFindingsFN(activeComplianceId);
      } else if (activeDepartmentId) {
        getDepartmentsFindingsFN(activeDepartmentId);
      }
    } catch (err) {
      console.error("handleCreateAction error:", err);
    }
  };

  const closeAction = async (data) => {
        await updateControlServerData(data);

        setIsActionOpen(false);
    };


    const closeFinding = async (data, finding_id) => {
        if (!finding_id)
            return
        setIsFindingOpen(false)
        setFindingID(null)
      //console.log(data)
      await updateFindingFN(data, finding_id)
      if (isComp) {
        if(activeComplianceId)
        getComplianceFindingsFN(activeComplianceId);
      } else {
        if(activeDepartmentId)
        getDepartmentsFindingsFN(activeDepartmentId);
      }
      ////console.log("close finding", data, " ", finding_id)

    }

    const updateControlServerData = async (data) => {
        // adjust dates if you really need +1 day

        ////console.log("action_id ", action_id)
        const updatedData = { ...data };
        if (updatedData.StartDate) {
            const d = new Date(updatedData.StartDate);
            d.setDate(d.getDate() + 1);
            updatedData.StartDate = d.toISOString().split("T")[0];
        }
        if (updatedData.EndDate) {
            const d = new Date(updatedData.EndDate);
            d.setDate(d.getDate() + 1);
            updatedData.EndDate = d.toISOString().split("T")[0];
        }

        setIsLoading(true);
        try {
            // IMPORTANT: await the thunk
            ////console.log("save it ", updatedData)
            const saved = await editActionFN(risk_id, action_id, updatedData);
            return saved; // bubble up if you want
        } finally {
            setIsLoading(false);
        }
    };


    const [statusView, setStatusView] = useState("All"); // "All" | "Open" | "Completed"

    // helper: returns true if finding is completed
    const isCompletedFinding = (f) => (f.status?.toLowerCase?.() === "completed");

    // if you already compute `filteredFindings`, wrap it once more by status:
    const statusFilteredFindings = useMemo(() => {
        if (statusView === "All") return filteredFindings;
        if (statusView === "Completed") return filteredFindings.filter(isCompletedFinding);
        // "Open"
        return filteredFindings.filter((f) => !isCompletedFinding(f));
    }, [filteredFindings, statusView]);


    const priorityChip = (p) => {
        if (!p || p === "—") {
            return <span className="inline-flex items-center text-[11px] px-2 py-0.5 rounded border border-gray-200 bg-gray-50 text-gray-600">—</span>;
        }
        const raw = String(p).trim();
        const map = {
            Critical: "bg-red-100 text-red-700 border-red-200",
            High: "bg-orange-100 text-orange-700 border-orange-200",
            Medium: "bg-yellow-100 text-yellow-800 border-yellow-200",
            Low: "bg-green-100 text-green-700 border-green-200",
        };
        const cls = map[raw] || "bg-gray-100 text-gray-700 border-gray-200";
        const label = translatePriorityDisplay(raw, t) ?? raw;
        return <span className={`inline-flex items-center text-[11px] px-2 py-0.5 rounded border ${cls}`}>{label}</span>;
    };

    const statusChip = (s) => {
        const raw = String(s ?? "").trim() || "Open";
        const lk = raw.toLowerCase();
        const styleByLower = {
            open: "bg-blue-100 text-blue-700 border-blue-200",
            "in progress": "bg-purple-100 text-purple-700 border-purple-200",
            resolved: "bg-emerald-100 text-emerald-700 border-emerald-200",
            closed: "bg-gray-200 text-gray-700 border-gray-300",
            problem: "bg-rose-100 text-rose-700 border-rose-200",
        };
        const cls = styleByLower[lk] || "bg-gray-100 text-gray-700 border-gray-200";
        const label = translateFindingStatusDisplay(raw, t);
        return <span className={`inline-flex items-center text-[11px] px-2 py-0.5 rounded border ${cls}`}>{label}</span>;
    };




    const normalizeStatus = (s) => (s === "Problem" ? "In Progress" : s || "Open");

    function StatCard({ statType, label, value }) {
        let Icon;
        let iconColor = "";

        switch (statType) {
            case "total":
                Icon = FiAlertTriangle;
                iconColor = "text-gray-400";
                break;
            case "inProgress":
                Icon = FiXCircle;
                iconColor = "text-red-500";
                break;
            case "open":
                Icon = FiClock;
                iconColor = "text-blue-500";
                break;
            case "closed":
                Icon = FiCheckCircle;
                iconColor = "text-green-500";
                break;
            default:
                Icon = null;
        }

        return (
            <div className="rounded-xl border border-gray-200 bg-white p-4 flex flex-col justify-between">
                <div className="flex items-center justify-between">
                    <div className="text-xs text-gray-500">{label}</div>
                    {Icon && <Icon className={`w-4 h-4 ${iconColor}`} />}
                </div>
                <div className="mt-1 text-2xl font-normal text-[#0E0E0E]">{value}</div>
            </div>
        );
    }

    const [query, setQuery] = useState("");

    const [typeView, setTypeView] = useState("All");     // All | numeric string

    // --- Derived type options from findings ---
    const typeOptions = useMemo(() => {
        const set = new Set();
        (findings ?? []).forEach((f) => {
            if (f?.type !== undefined && f?.type !== null) set.add(String(f.type));
        });
        return ["All", ...Array.from(set).sort((a, b) => Number(a) - Number(b))];
    }, [findings]);

    // --- Status + type + search filter ---
    const statusFiltered = useMemo(() => {
        return (findings ?? []).filter((f) => {
            const s = normalizeStatus(f.status);
            if (statusView !== "All" && s !== statusView) return false;
            if (typeView !== "All" && String(f.type) !== String(typeView)) return false;

            if (!query.trim()) return true;
            const q = query.toLowerCase();
            return (
                String(f.finding_id ?? f.id ?? "").toLowerCase().includes(q) ||
                (f.risk_title || "").toLowerCase().includes(q) ||
                (f.title || "").toLowerCase().includes(q) ||
                (f.finding_text || "").toLowerCase().includes(q) ||
                (f.recommendation_text || "").toLowerCase().includes(q)
            );
        });
    }, [findings, query, statusView, typeView]);







    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(6);

    // reset to first page when the filter list changes
    useEffect(() => { setPage(1); }, [statusFiltered, pageSize]);

    // stable, paginated slice (keeps order you already applied)
    const total = statusFiltered?.length || 0;
    const totalPages = Math.max(1, Math.ceil(total / pageSize));
    const startIdx = (page - 1) * pageSize;
    const endIdx = Math.min(startIdx + pageSize, total);
    const pageRows = useMemo(() => (statusFiltered || []).slice(startIdx, endIdx), [statusFiltered, startIdx, endIdx]);

    const goPrev = () => setPage(p => Math.max(1, p - 1));
    const goNext = () => setPage(p => Math.min(totalPages, p + 1));

    const buildPager = (current, last) => {
        if (last <= 7) return Array.from({ length: last }, (_, i) => i + 1);
        const out = new Set([1, 2, last - 1, last, current - 1, current, current + 1]);
        const sorted = [...out].filter(n => n >= 1 && n <= last).sort((a, b) => a - b);
        const result = [];
        for (let i = 0; i < sorted?.length; i++) {
            result.push(sorted[i]);
            if (sorted[i + 1] && sorted[i + 1] - sorted[i] > 1) result.push('…');
        }
        return result;
    };
    const pagerItems = buildPager(page, totalPages);

return (
  <div className={isRiskCenter ? "w-full" : "w-full bg-gray-50 min-h-[100dvh] overflow-y-auto pb-28"}>
    <PageSection className={hideStatsAndToggle ? "p-0" : isRiskCenter ? "p-4 sm:p-6" : "px-6 md:px-10 xl:px-16 2xl:px-24 pt-8 md:pt-5 pb-16"}>
      {!isRiskCenter && (
        <h1 className="text-xl font-semibold text-gray-900 mb-4">
          {t("findingsPage.title")}
        </h1>
      )}

      {!hideStatsAndToggle && <KpiStrip items={findingsKpiItems} />}

      {!hideStatsAndToggle && (
      <FilterBar>
          {!props.hideViewToggle && (
          <ModuleViewToggle
            activeView="findings"
            onSelectFindings={onSelectFindings}
            onSelectActions={onSelectActions}
            findingsLabel={t("findingsPage.toggleFindings")}
            actionsLabel={t("findingsPage.toggleActions")}
          />
          )}
        <SearchInput
          value={query}
          onChange={setQuery}
          placeholder={t("findingsPage.searchPlaceholder")}
          className="min-w-[220px]"
        />
        <div className="relative flex-shrink-0">
          <select
            value={typeView}
            onChange={(e) => setTypeView(e.target.value)}
            className="h-9 rounded-lg border border-gray-200 bg-white px-3 text-[13px] text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
          >
            {typeOptions.map((typeOpt) => (
              <option key={typeOpt} value={typeOpt}>
                {typeOpt === "All"
                  ? t("findingsPage.filters.all")
                  : typeOpt === "0"
                    ? t("findingsPage.filters.firstLine")
                    : typeOpt === "1"
                      ? t("findingsPage.filters.secondLine")
                      : t("findingsPage.filters.typeOther", { value: typeOpt })}
              </option>
            ))}
          </select>
        </div>
        <div className="relative flex-shrink-0">
          <select
            value={statusView}
            onChange={(e) => setStatusView(e.target.value)}
            className="h-9 rounded-lg border border-gray-200 bg-white px-3 text-[13px] text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
          >
            <option value="All">{t("findingsPage.filters.all")}</option>
            <option value="Open">{t("findingsPage.filters.open")}</option>
            <option value="In Progress">{t("findingsPage.filters.inProgress")}</option>
            <option value="Closed">{t("findingsPage.filters.closed")}</option>
          </select>
        </div>
      </FilterBar>
      )}

      {/* Add finding button — shown above table once findings exist */}
      {props.onAddFinding && findings.length > 0 && (
        <div className="flex justify-end mb-3">
          <button
            type="button"
            onClick={props.onAddFinding}
            className="px-3 py-1.5 rounded-lg bg-[#0B0B0F] text-white text-[12px] font-medium hover:opacity-90 transition"
          >
            {t("controlOverlay.newFinding")}
          </button>
        </div>
      )}

      {/* FINDINGS_TABLE_START */}
      <div className="w-full">
        <div className={pageRows?.length > 0 || isFindingsLoading ? "border border-gray-200 rounded-xl overflow-hidden bg-white" : "rounded-xl overflow-hidden"}>
          <table className="w-full text-sm table-auto" style={{ tableLayout: "auto" }}>
            {pageRows?.length > 0 && (
            <thead>
              <tr style={{ height: 28 }}>
                <th style={{ background: "#f9fafb", color: "#1F1F1F", fontSize: 13, fontWeight: 400, padding: "4px 12px", height: 28, borderBottom: "1px solid #e5e7eb", width: "20%" }} className="text-left">{t("findingsPage.headers.findingId")}</th>
                <th style={{ background: "#f9fafb", color: "#1F1F1F", fontSize: 13, fontWeight: 400, padding: "4px 12px", height: 28, borderBottom: "1px solid #e5e7eb", width: "40%" }} className="text-left">{t("findingsPage.headers.title")}</th>
                <th style={{ background: "#f9fafb", color: "#1F1F1F", fontSize: 13, fontWeight: 400, padding: "4px 12px", height: 28, borderBottom: "1px solid #e5e7eb", width: "120px" }} className="text-left whitespace-nowrap">{t("findingsPage.headers.findingDate")}</th>
                <th style={{ background: "#f9fafb", color: "#1F1F1F", fontSize: 13, fontWeight: 400, padding: "4px 12px", height: 28, borderBottom: "1px solid #e5e7eb", width: "120px" }} className="text-left">{t("findingsPage.headers.status")}</th>
                <th style={{ background: "#f9fafb", color: "#1F1F1F", fontSize: 13, fontWeight: 400, padding: "4px 12px", height: 28, borderBottom: "1px solid #e5e7eb", width: "80px" }} className="text-left">{t("findingsPage.headers.action")}</th>
                <th style={{ background: "#f9fafb", color: "#1F1F1F", fontSize: 13, fontWeight: 400, padding: "4px 12px", height: 28, borderBottom: "1px solid #e5e7eb", width: "40px" }} />
              </tr>
            </thead>
            )}
            <tbody>
              {pageRows?.length > 0 ? (
                pageRows.map((f) => {
                  const id = rowKey(f);
                  const year = new Date(f.finding_date || Date.now()).getFullYear();
                  const formattedId = `FIN-${year}-${String(f.finding_id ?? f.id ?? 0).toString().padStart(3, "0")}`;
                  const title = f.finding_text || f.title || "—";
                  const statusRaw = f.status || "Open";
                  const findingDate = f.finding_date ? new Date(f.finding_date).toLocaleDateString() : "—";
                  const actionLabel = f.action_id ? t("findingsPage.actions.view") : t("findingsPage.actions.create");
                  const onActionClick = (e) => {
                    e.stopPropagation();
                    if (f.action_id) handleViewAction?.(f);
                    else handleCreateAction?.(f);
                  };
                  return (
                    <tr key={id} className="border-t border-gray-100 hover:bg-gray-50 cursor-pointer" onClick={() => handleViewFinding?.(f)}>
                      <td className="px-3 py-2 text-gray-700 font-medium">{formattedId}</td>
                      <td className="px-3 py-2 text-gray-900">{title}</td>
                      <td className="px-3 py-2 text-gray-700 whitespace-nowrap">{findingDate}</td>
                      <td className="px-3 py-2">{statusChip(statusRaw)}</td>
                      <td className="px-3 py-2" onClick={(e) => e.stopPropagation()}>
                        <button type="button" onClick={onActionClick} className="px-2.5 py-1 text-xs rounded-md border border-gray-200 hover:bg-gray-50 text-gray-700">
                          {actionLabel}
                        </button>
                      </td>
                      <td className="px-2 py-2" onClick={(e) => e.stopPropagation()}>
                        {props.onDeleteFinding && (
                          <TfiTrash size={14} onClick={() => props.onDeleteFinding(f.finding_id ?? f.id)} className="text-gray-400 hover:text-red-500 transition-colors duration-150 cursor-pointer" />
                        )}
                      </td>
                    </tr>
                  );
                })
              ) : isFindingsLoading ? (
                <tr>
                  <td colSpan={6} className="px-3 py-8 text-center">
                    <div className="flex flex-col items-center gap-2">
                      <PageSpinner size="md" />
                      <span className="text-gray-500 text-sm">{t("findingsPage.loadingState")}</span>
                    </div>
                  </td>
                </tr>
              ) : (
                <tr>
                  <td colSpan={6}>
                    <div className="flex flex-col items-center justify-center gap-3 py-8 px-4 m-3 rounded-xl border-2 border-dashed border-gray-200">
                      <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center">
                        <svg className="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
                          <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
                        </svg>
                      </div>
                      <div className="text-center">
                        <p className="text-sm font-medium text-gray-700">{t("findingsPage.emptyState")}</p>
                        <p className="text-xs text-gray-400 mt-1">{t("findingsPage.emptyStateHint")}</p>
                      </div>
                      {props.onAddFinding && (
                        <button type="button" onClick={props.onAddFinding} className="px-4 py-2 rounded-lg bg-[#0B0B0F] text-white text-[13px] font-medium hover:opacity-90 transition">
                          {t("controlOverlay.newFinding")}
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    <div className="border-t border-gray-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 px-4 py-3">
      <div className="text-xs text-gray-500">
        {t("findingsPage.pagination.showing")}{" "}
        <span className="font-medium text-gray-700">
          {total ? startIdx + 1 : 0}
        </span>
        –
        <span className="font-medium text-gray-700">
          {Math.max(startIdx + pageRows?.length, 0)}
        </span>{" "}
        {t("findingsPage.pagination.of")}{" "}
        <span className="font-medium text-gray-700">{total}</span>{" "}
        {t("findingsPage.pagination.findings")}
      </div>

      <div className="flex items-center gap-1">
        <button
          onClick={goPrev}
          disabled={pagerItems?.length <= 1 || pageRows?.length === 0}
          className="h-8 w-8 rounded-md border border-gray-300 bg-white text-xs text-gray-700
            disabled:opacity-50 hover:bg-gray-50 flex items-center justify-center"
          aria-label="Previous page"
        >
          ‹
        </button>

        {pagerItems.map((it, idx) =>
          it === "…" ? (
            <span
              key={`ellipsis-${idx}`}
              className="px-2 text-xs text-gray-500"
            >
              …
            </span>
          ) : (
            <button
              key={it}
              onClick={() => setPage(it)}
              className={`h-8 min-w-8 px-3 rounded-md border text-xs
                ${
                  it === page
                    ? "border-gray-900 bg-gray-900 text-white"
                    : "border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
                }`}
              aria-current={it === page ? "page" : undefined}
            >
              {it}
            </button>
          )
        )}

        <button
          onClick={goNext}
          disabled={pagerItems?.length <= 1 || pageRows?.length === 0}
          className="h-8 w-8 rounded-md border border-gray-300 bg-white text-xs text-gray-700
            disabled:opacity-50 hover:bg-gray-50 flex items-center justify-center"
          aria-label="Next page"
        >
          ›
        </button>
      </div>
    </div>
    </PageSection>

    {/* Popups same as before */}
      <ActionOverlay
        open={isActionOpen}
        onClose={() => setIsActionOpen(false)}
        closeAction={closeAction}
        risk_id={risk_id}
        action_id={action_id}
      />

    <FindingOverlay
      open={isFindingOpen}
      key={findingId || "new_finding"}
      finding_id={findingId}
      onClose={() => setIsFindingOpen(false)}
      closeFinding={(data, id, e) => {
        e?.stopPropagation?.();
        closeFinding(data, id);
      }}
    />
  </div>
);




};




const mapStateToProps = (state, ownProps) => {
    return {
        departments: state.department.departments,
        actions: state.department.actions,
        actions_stats: state.department.actions_data,
        actionsDataScopeKey: state.department.actionsDataScopeKey,
        actionsLoading: state.department.actionsLoading,
        profile: state.profile.profile,
        initialfindings: ownProps.initialfindings ?? (Array.isArray(state.department.finding_data) ? state.department.finding_data : state.department.finding_data?.findings),
        compFindings: Array.isArray(state.compliance.finding_data) ? state.compliance.finding_data : state.compliance.finding_data?.findings,
        findingsScopeKey: state.department.findingsScopeKey,
        findingsLoading: state.department.findingsLoading,
        compFindingsScopeKey: state.compliance.findingsScopeKey,
        compFindingsLoading: state.compliance.findingsLoading,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getDepartmentsFN: () => dispatch(getDepartments()),
        getDepartmentsActionFN: (department_id) => dispatch(getDepartmentsAction(department_id)),
        getDepartmentsActionDataFN: (department_id) => dispatch(getDepartmentsActionData(department_id)),
        getDepartmentsFindingsFN: (department_id) => dispatch(getDepartmentsFindings(department_id)),
        getComplianceFindingsFN:(c) => dispatch(getComplianceFindings(c)),
        addActionCommentsFN: (action_id, comments, department_id) => dispatch(addActionComments(action_id, comments, department_id)),
        editActionCommentsFN: (comment_iid, comments, department_id) => dispatch(editActionComments(comment_iid, comments, department_id)),
        editActionProgressFN: (action_id, progress) => dispatch(editActionProgress(action_id, progress)),
        editActionFN: (risk_id, action_id, action) => dispatch(editAction(risk_id, action_id, action)),
        makeActionsFN: (items) => dispatch(addActionsFromFindings(items)),
        markFindingsCompleteFN: (items) => dispatch(markFindingsComplete(items)),
        markFindingsOpenFN: (items) => dispatch(markFindingsOpen(items)),
        createActionFromFindingFN: (item) => dispatch(createActionFromFinding(item)),
        updateFindingFN: (data, id) => dispatch(updateFinding(data, id)),

    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(FindingsComponent);
